<app-performance>
    <app-data-grid-comp
        [tableId]="db_tables.GoalTypes"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridId]="gridId"
        [gridData]="gridData"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="GoalTypes"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        [clearSelectedItems]="clearSelectedItems"
        searchable="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitOpenDialogEvent)="getGoalType($event)"
        (emitDeleteEvent)="deleteGoalTypes($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        
    ></app-data-grid-comp>
</app-performance>
